export const STIPOP_API_HOST = process.env.REACT_APP_STIPOP_API_HOST
export const STIPOP_API_KEY = process.env.REACT_APP_STIPOP_API_KEY

export const DMM_API_HOST = process.env.REACT_APP_DMM_API_HOST
export const DMM_TEST_API_HOST = process.env.REACT_APP_DMM_TEST_API_HOST
export const DMM_API_KEY = process.env.REACT_APP_DMM_API_KEY